import * as React from 'react'
import errorImg from '../common/img/error_img.svg'
import './index.less'

class  Errors extends React.Component{
    constructor(props) {
      super()
    }
    render(){
        return(
            <div className='errorPage'>
            <img src={errorImg} alt=""/>
                <div>
                    <h3>页面走丢了......</h3>
                    <p >刷新页面再试试</p>
                    <span
                      onClick={()=>{
                           window.location.reload()
                      }}
                    >刷新此页面</span>
                </div>
        </div>
        )
    }
      
    }
export default Errors